import React, { useState, useEffect, useCallback } from 'react';
import { API, apiFetch } from '../api';

const DAYS = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
};

const s = {
  page: { padding: '20px 16px 40px', maxWidth: '600px', margin: '0 auto' },
  heading: { fontSize: '20px', fontWeight: '700', color: '#222', marginBottom: '4px' },
  sub: { fontSize: '13px', color: '#888', marginBottom: '20px' },

  newBtn: {
    display: 'block', width: '100%', padding: '13px',
    background: '#DB3267', color: '#fff', borderRadius: '10px',
    fontSize: '15px', fontWeight: '700', border: 'none', cursor: 'pointer',
    marginBottom: '20px',
  },

  formCard: {
    background: '#fff', borderRadius: '14px', padding: '20px',
    marginBottom: '20px', boxShadow: '0 2px 12px rgba(219,50,103,0.1)',
    border: '1.5px solid #f0b8cc',
  },
  formTitle: { fontSize: '16px', fontWeight: '700', color: '#222', marginBottom: '16px' },
  label: { display: 'block', fontSize: '12px', fontWeight: '700', color: '#555', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  textarea: {
    width: '100%', padding: '11px 13px', borderRadius: '8px',
    border: '1.5px solid #e0e0e0', fontSize: '14px', lineHeight: '1.5',
    outline: 'none', resize: 'vertical', boxSizing: 'border-box',
    fontFamily: 'inherit',
  },
  charCount: { fontSize: '11px', color: '#bbb', textAlign: 'right', marginTop: '3px', marginBottom: '14px' },
  select: {
    width: '100%', padding: '11px 13px', borderRadius: '8px',
    border: '1.5px solid #e0e0e0', fontSize: '14px',
    background: '#fff', outline: 'none', marginBottom: '14px',
    appearance: 'auto',
  },
  timeRow: { display: 'flex', gap: '10px', marginBottom: '20px' },
  timeInput: {
    flex: 1, padding: '11px 13px', borderRadius: '8px',
    border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none',
  },
  formActions: { display: 'flex', gap: '10px' },
  saveBtn: {
    flex: 1, padding: '12px', background: '#DB3267', color: '#fff',
    borderRadius: '8px', fontSize: '14px', fontWeight: '700', border: 'none', cursor: 'pointer',
  },
  cancelBtn: {
    padding: '12px 18px', background: '#f5f4f8', color: '#888',
    borderRadius: '8px', fontSize: '14px', fontWeight: '600', border: 'none', cursor: 'pointer',
  },

  msgCard: {
    background: '#fff', borderRadius: '12px', padding: '16px 18px',
    marginBottom: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    borderLeft: '4px solid #DB3267',
  },
  msgCardPaused: {
    borderLeft: '4px solid #e0e0e0', opacity: 0.65,
  },
  msgText: { fontSize: '14px', color: '#222', marginBottom: '6px', lineHeight: '1.5' },
  msgMeta: { fontSize: '12px', color: '#aaa', marginBottom: '10px' },
  msgActions: { display: 'flex', gap: '8px', flexWrap: 'wrap' },

  pauseBtn: {
    padding: '6px 14px', background: '#fff3e0', color: '#e65100',
    borderRadius: '6px', fontSize: '12px', fontWeight: '600',
    border: '1px solid #ffe0b2', cursor: 'pointer',
  },
  resumeBtn: {
    padding: '6px 14px', background: '#e8f5e9', color: '#2e7d32',
    borderRadius: '6px', fontSize: '12px', fontWeight: '600',
    border: '1px solid #a5d6a7', cursor: 'pointer',
  },
  sendNowBtn: {
    padding: '6px 14px', background: '#fce8ef', color: '#DB3267',
    borderRadius: '6px', fontSize: '12px', fontWeight: '600',
    border: '1px solid #f0b8cc', cursor: 'pointer',
  },
  deleteBtn: {
    padding: '6px 12px', background: '#fff', color: '#e53935',
    borderRadius: '6px', fontSize: '12px', fontWeight: '600',
    border: '1px solid #ffcdd2', cursor: 'pointer', marginLeft: 'auto',
  },

  statusPill: {
    display: 'inline-block', padding: '2px 10px', borderRadius: '20px',
    fontSize: '11px', fontWeight: '700', marginBottom: '8px',
  },
  empty: { textAlign: 'center', padding: '50px 20px', color: '#bbb' },
  emptyIcon: { fontSize: '36px', marginBottom: '10px' },
  emptyText: { fontSize: '14px' },

  infoBox: {
    background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '10px',
    padding: '12px 16px', marginBottom: '20px', fontSize: '13px', color: '#795548',
    lineHeight: '1.5',
  },
};

const EMPTY_FORM = { message: '', groupId: '', dayOfWeek: 1, sendTime: '09:00' };

export default function AdminNotifications() {
  const [messages, setMessages]   = useState([]);
  const [groups, setGroups]       = useState([]);
  const [showForm, setShowForm]   = useState(false);
  const [form, setForm]           = useState(EMPTY_FORM);
  const [saving, setSaving]       = useState(false);
  const [loading, setLoading]     = useState(true);
  const [sendingId, setSendingId] = useState(null);
  const [sendResult, setSendResult] = useState(null); // { id, sent, failed, total }

  const load = useCallback(async () => {
    const [mRes, gRes] = await Promise.all([
      apiFetch(`${API}/notifications`),
      apiFetch(`${API}/groups`),
    ]);
    const mData = await mRes.json();
    const gData = await gRes.json();
    if (mData.ok) setMessages(mData.messages);
    if (gData.ok) setGroups(gData.groups);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  async function save() {
    if (!form.message.trim()) return;
    setSaving(true);
    await apiFetch(`${API}/notifications`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        message:    form.message.trim(),
        groupIds:   form.groupId ? [parseInt(form.groupId)] : [],
        dayOfWeek:  form.dayOfWeek,
        sendTime:   form.sendTime,
      }),
    });
    setSaving(false);
    setShowForm(false);
    setForm(EMPTY_FORM);
    await load();
  }

  async function toggle(id) {
    await apiFetch(`${API}/notifications/${id}`, {
      method:  'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ action: 'toggle' }),
    });
    await load();
  }

  async function remove(id) {
    if (!window.confirm('Delete this scheduled message?')) return;
    await apiFetch(`${API}/notifications/${id}`, { method: 'DELETE' });
    await load();
  }

  async function sendNow(id) {
    setSendingId(id);
    setSendResult(null);
    const res  = await apiFetch(`${API}/notifications/${id}/send`, { method: 'POST' });
    const data = await res.json();
    setSendingId(null);
    if (!data.ok) {
      setSendResult({ id, error: data.error });
    } else {
      setSendResult({ id, sent: data.sent, failed: data.failed, total: data.total });
      await load(); // refresh last_sent
    }
  }

  function groupLabel(groupIds) {
    if (!groupIds || groupIds.length === 0) return 'All Staff';
    const g = groups.find(x => x.id === groupIds[0]);
    return g ? g.name : 'Unknown group';
  }

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Notification Scheduler</h1>
      <p style={s.sub}>Schedule weekly SMS messages to staff groups</p>


      {!showForm && (
        <button style={s.newBtn} onClick={() => setShowForm(true)}>
          + New Scheduled Message
        </button>
      )}

      {/* New message form */}
      {showForm && (
        <div style={s.formCard}>
          <div style={s.formTitle}>New Scheduled Message</div>

          <label style={s.label}>Message</label>
          <textarea
            style={s.textarea}
            rows={4}
            maxLength={160}
            placeholder="e.g. Good morning! Let's make some Care Moments this week 💪"
            value={form.message}
            onChange={e => setForm({ ...form, message: e.target.value })}
          />
          <div style={s.charCount}>{form.message.length} / 160 characters</div>

          <label style={s.label}>Send to</label>
          <select
            style={s.select}
            value={form.groupId}
            onChange={e => setForm({ ...form, groupId: e.target.value })}
          >
            <option value="">All Staff</option>
            {groups.map(g => (
              <option key={g.id} value={g.id}>{g.name}</option>
            ))}
          </select>

          <div style={s.timeRow}>
            <div style={{ flex: 1 }}>
              <label style={s.label}>Send every</label>
              <select
                style={{ ...s.select, marginBottom: 0 }}
                value={form.dayOfWeek}
                onChange={e => setForm({ ...form, dayOfWeek: parseInt(e.target.value) })}
              >
                {Object.entries(DAYS).map(([val, label]) => (
                  <option key={val} value={val}>{label}</option>
                ))}
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={s.label}>At time</label>
              <input
                type="time"
                style={s.timeInput}
                value={form.sendTime}
                onChange={e => setForm({ ...form, sendTime: e.target.value })}
              />
            </div>
          </div>

          <div style={s.formActions}>
            <button
              style={{ ...s.saveBtn, opacity: (!form.message.trim() || saving) ? 0.6 : 1 }}
              onClick={save}
              disabled={!form.message.trim() || saving}
            >
              {saving ? 'Saving...' : 'Schedule Message'}
            </button>
            <button style={s.cancelBtn} onClick={() => { setShowForm(false); setForm(EMPTY_FORM); }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Scheduled messages list */}
      {loading ? (
        <div style={s.empty}>Loading...</div>
      ) : messages.length === 0 && !showForm ? (
        <div style={s.empty}>
          <div style={s.emptyIcon}>📅</div>
          <div style={s.emptyText}>No scheduled messages yet</div>
        </div>
      ) : (
        messages.map(m => (
          <div key={m.id} style={{ ...s.msgCard, ...(m.active ? {} : s.msgCardPaused) }}>
            <span style={{
              ...s.statusPill,
              background: m.active ? '#e8f5e9' : '#f5f5f5',
              color: m.active ? '#2e7d32' : '#9e9e9e',
            }}>
              {m.active ? 'Active' : 'Paused'}
            </span>

            <div style={s.msgText}>"{m.message}"</div>

            <div style={s.msgMeta}>
              {groupLabel(m.groupIds)} · Every {DAYS[m.dayOfWeek]} at {m.sendTime}
              {m.lastSent && ` · Last sent ${m.lastSent}`}
            </div>

            {/* Send result feedback */}
            {sendResult && sendResult.id === m.id && (
              <div style={{
                margin: '8px 0',
                padding: '8px 12px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                background: sendResult.error ? '#fce4ec' : '#e8f5e9',
                color: sendResult.error ? '#c62828' : '#2e7d32',
              }}>
                {sendResult.error
                  ? `Error: ${sendResult.error}`
                  : `Sent to ${sendResult.sent} of ${sendResult.total} people${sendResult.failed > 0 ? ` (${sendResult.failed} failed)` : ''}`
                }
              </div>
            )}

            <div style={s.msgActions}>
              <button style={m.active ? s.pauseBtn : s.resumeBtn} onClick={() => toggle(m.id)}>
                {m.active ? 'Pause' : 'Resume'}
              </button>
              <button
                style={{ ...s.sendNowBtn, opacity: sendingId === m.id ? 0.6 : 1 }}
                onClick={() => sendNow(m.id)}
                disabled={sendingId === m.id}
              >
                {sendingId === m.id ? 'Sending...' : 'Send Now'}
              </button>
              <button style={s.deleteBtn} onClick={() => remove(m.id)}>
                Delete
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
